<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-8">{{ title }}</h3>
		<dl>
			<div v-for="(item, index) in data" :key="index">
				<dt
					v-if="item.title"
					class="relative pl-8 mt-5 mb-2 font-medium before:content-[''] before:absolute before:-left-0 before:top-1 before:w-3 before:h-3 before:rounded-full before:bg-dj-blue"
				>
					{{ item.title }}
				</dt>
				<dd v-if="item.text" class="pl-8">{{ item.text }}</dd>
			</div>
		</dl>
	</DjBox>
</template>

<script lang="ts">
import DjBox from "./DjBox.vue";

import { defineComponent, PropType } from "vue";

type DataType = {
	title: string;
	text: string;
};

export default defineComponent({
	name: "DjBoxJobList",
	components: {
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		data: {
			type: Array as PropType<DataType[]>,
			required: true,
		},
	},
});
</script>
